import * as React from 'react'

import { F0Button } from '@factorialco/f0-react'
import { Pencil } from '@factorialco/f0-react/icons/app'
import uniq from 'lodash/uniq'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import EditShiftSidepanel from 'modules/shift_management/components/ShiftManagement/EditShiftSidepanel'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'

const EditShiftsButton = () => {
  const [{ view }] = useSchedule()
  const { shifts: selectedShifts, kind, isResolvingGridSelection } = useSelectionState()

  const [openEditSidepanel, setOpenEditSidepanel] = React.useState<boolean>(false)

  // We don't allow editing backup shifts for now
  const shifts = Object.values(selectedShifts).filter((s) => !s.isBackup)
  const disabled =
    !shifts.length ||
    isResolvingGridSelection ||
    (kind != null && !['cells', 'event', 'row'].includes(kind))

  const onEditAction = () => {
    const employeesShifts = uniq(shifts.map((s) => s.employeeId))
    const colors = uniq(shifts.map((s) => s.color))
    const shiftType = shifts.map((s) => s.typeForEvents)
    track(trackingEvents.shiftManagement.editShiftStart, {
      number_of_impacted_shifts: shifts.length,
      number_of_impacted_employees: employeesShifts.length,
      shift_ids: shifts.map((s) => s.id),
      view: view.viewType,
      view_type_by: view.groupType,
      from: 'top_bar_button',
      color: colors,
      shift_type: shiftType,
    })

    return setOpenEditSidepanel(true)
  }

  return (
    <>
      <F0Button
        variant="outline"
        onClick={onEditAction}
        disabled={disabled}
        icon={Pencil}
        label={i18n.t('shift_management.edit_shifts.new_title')}
      />
      {openEditSidepanel && (
        <EditShiftSidepanel shifts={shifts} onClose={() => setOpenEditSidepanel(false)} />
      )}
    </>
  )
}

export default EditShiftsButton
